module.exports = __webpack_public_path__ + "img/brandmeLogo-provicional.4d561d2f.png";